export const TITULO_PAGINA_RENOVACAO = 'Renovação do plano'

export const DESCRICAO_PAGINA_RENOVACAO = 'Renove o seu plano para mais um ano conosco e ganhe um brinde exclusivo!'

export const LABEL_BOTAO_RENOVACAO = 'Renovar agora'

export const BASE_PROPRIEDADE_ASSINATURA_RENOVACAO = 'assinatura_id'

export const BASE_PROPRIEDADE_BRINDE_RENOVACAO = 'brinde'

export const BASE_PROPRIEDADE_ENTREGA_RENOVACAO = 'entrega'

export const BASE_PROPRIEDADE_PAGAMENTO_RENOVACAO = 'pagamento'

export const BASE_PROPRIEDADE_CUPONS_RENOVACAO = 'cupons'

export const BASE_PROPRIEDADE_PAGAMENTO_CARTAO_RENOVACAO = 'cartao_credito'

export const SUCESSO_FAZER_RENOVACAO_CARTAO = 'Renovação de plano realizado com sucesso!'

export const SUCESSO_FAZER_RENOVACAO_PIX = 'A renovação de plano será realizada assim que você fizer o pagamento do seu pix.'

export const BASES_OBRIGATORIAS_RENOVACAO = [
  BASE_PROPRIEDADE_ASSINATURA_RENOVACAO,
  BASE_PROPRIEDADE_BRINDE_RENOVACAO,
  BASE_PROPRIEDADE_ENTREGA_RENOVACAO,
  BASE_PROPRIEDADE_PAGAMENTO_RENOVACAO
]

export const BASES_OPCIONAIS_RENOVACAO = [ BASE_PROPRIEDADE_CUPONS_RENOVACAO ]
